// extracted by mini-css-extract-plugin
module.exports = {"AccountContent":"styles_AccountContent__zyFWv","navigation":"styles_navigation__LsK23","content":"styles_content__J21Yw","wide":"styles_wide__I_CBA","full":"styles_full__t8s6e"};